import { defineMessages, useIntl } from 'react-intl';
import cx from 'clsx';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import { iconRegistry } from './icons';

const messages = defineMessages({
  defaultHeading: {
    id: 'iconCards.default.heading',
    defaultMessage: 'Conference Objectives',
  },
});

export type IconCardColor = 'purple' | 'gray' | 'tan' | 'plum';

export type IconCardItem = {
  icon?: string;
  color?: IconCardColor;
  text?: string;
};

export type IconCardsData = {
  heading?: string;
  items?: IconCardItem[];
};

const IconCardsView = ({ data }: { data: IconCardsData }) => {
  const intl = useIntl();
  const items = data.items || [];

  return (
    <section className="block-icon-cards">
      <h2 className="icon-cards__heading">
        {data.heading || intl.formatMessage(messages.defaultHeading)}
      </h2>

      {items.length > 0 && (
        <ul className="icon-cards__grid">
          {items.map((item, i) => {
            const icon = item.icon || 'coral';
            const color = item.color || 'purple';
            return (
              <li
                key={i}
                className={cx('icon-cards__card', `icon-cards__card--${color}`)}
              >
                <span className="icon-cards__icon" aria-hidden="true">
                  <Icon name={iconRegistry[icon]} size="48px" />
                </span>
                {item.text && <p className="icon-cards__text">{item.text}</p>}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};

export default IconCardsView;
